import { Controller } from '@hotwired/stimulus'

export default class ShelterIntegrationController extends Controller {
  static targets = [
    'content',
    'overlay',
    'buttonsContainer',
    'provisionLoadingContainer',
    'checkLoadingContainer'
  ]

  showLoader () {
    this.overlayTarget.classList.remove('hidden')
    this.contentTarget.classList.add('hidden')
  }

  showProvisioningLoading () {
    this.hideButtons()
    if (this.hasProvisionLoadingContainerTarget) {
      this.provisionLoadingContainerTarget.classList.remove('hidden')
    }
  }

  showCheckProvisioned () {
    this.hideButtons()
    if (this.hasCheckLoadingContainerTarget) {
      this.checkLoadingContainerTarget.classList.remove('hidden')
    }
  }

  hideButtons () {
    if (this.hasButtonsContainerTarget) {
      this.buttonsContainerTarget.classList.add('hidden')
    }
  }
}
